import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import VueScrollTo from 'vue-scrollto'
import 'element-plus/dist/index.css'
import 'normalize.css'
import './style/index.scss'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import 'swiper/components/pagination/pagination.scss'
import 'swiper/components/scrollbar/scrollbar.scss'

createApp(App)
  .use(ElementPlus)
  .use(VueScrollTo)
  .use(store).use(router).mount('#app')
